import { Card, Flex, Typography } from 'antd';
import themeToken from '@lib/theme/tokens/index';
import styled from 'styled-components';
import { StyledButton } from '@/lib/theme/components/Button';
import { FundProjectionScreenOutlined, SolutionOutlined } from '@ant-design/icons';
import ShareTransferIcon from '@/components/Icons/ShareTransferIcon';
import SARIcon from '@/components/Icons/SARIcon';

const { Text } = Typography;

const packageTypeInfo = {
  valuation: {
    icon: <FundProjectionScreenOutlined width={45} height={45} />,
  },
  contract: {
    icon: <SolutionOutlined width={45} height={45} />,
  },
  sell: {
    icon: <ShareTransferIcon />,
  },
};

type UpgradePackageCardProps = {
  title?: string;
  price?: string;
  limit?: number;
  t: (t: string) => string;
  //   features?: string[];
  canBePurchased?: boolean;
  onClick?: () => void;
};

const FeaturesList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  li {
    margin-bottom: 8px;
    &:before {
      content: '•';
      color: ${themeToken['branding-secondary-6']};
      margin-right: 8px;
      font-size: 24px;
      line-height: 1;
      display: inline-block;
    }
  }
`;

function UpgradePackageCard({ title, price, limit, onClick, t, canBePurchased }: UpgradePackageCardProps) {
  const packageType = title?.toLowerCase() as keyof typeof packageTypeInfo;
  const { icon: packageIcon } = packageTypeInfo[packageType] || {};
  return (
    <Card style={{ marginTop: 16 }}>
      <div>
        <Flex align="start" justify="space-between" style={{ paddingInlineEnd: 20 }}>
          <Flex align="center" gap={8}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 45,
                fontSize: 20,
                height: 45,
                borderRadius: '50%',
                backgroundColor: themeToken['branding-secondary-1'],
                color: themeToken['branding-secondary-6'], // Example background color
              }}
            >
              {packageIcon}
            </div>
            <div>
              <Text
                style={{
                  marginLeft: 8,
                  fontSize: 16,
                  fontWeight: 700,
                  color: themeToken['branding-primary-6'], // Example text color
                }}
              >
                {title && t(title?.toLocaleLowerCase())}
              </Text>
            </div>
          </Flex>
          <Flex vertical align="center" gap={4}>
            <Text
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: themeToken.black, // Example text color
              }}
            >
              <SARIcon height={17} width={17} /> {price}
            </Text>
            <Text
              style={{
                color: themeToken['branding-natural-8'],
              }}
            >
              {t('packagePrice')}
            </Text>
          </Flex>
        </Flex>
        <Flex justify="space-between" align="center" gap={8} style={{ marginTop: 0 }}>
          <div style={{ marginTop: 0 }}>
            <FeaturesList>
              <li
                style={{
                  color: themeToken['branding-natural-8'],
                  fontWeight: 500,
                }}
              >
                {t('thePackageWillAdd')}{' '}
                <span style={{ fontWeight: 700 }}>
                  {limit} {title && t(title?.toLocaleLowerCase())}
                </span>
                .
              </li>
              <li
                style={{
                  color: themeToken['branding-natural-8'],
                  fontWeight: 500,
                }}
              >
                {t('availabilityDuringActiveSubscription')}
              </li>
            </FeaturesList>
          </div>
          <StyledButton type="primary" disabled={!canBePurchased} onClick={onClick}>
            {t('getPackage')}
          </StyledButton>
        </Flex>
      </div>
    </Card>
  );
}

export default UpgradePackageCard;
